<template>
  <div class="content-top tap-highlight" @click="onclickRank">
    <div class="content-top-first">
      <img class="top-img" src="/static/images/icons.png" alt="">
      <div class="top-first-eidt">
        <span class="we-info">测量排行</span>
        <span class="edit-span" @click.stop="onRouter">
          <img src='../../assets/images/data_edit.png' />
          个人资料
        </span>
      </div>
    </div>
    <div class="celiang-second">
      <div class="rank-box">
        <div class="user-box" v-show="showMyRank">
          <div class="img-box"><span class="img-inside tap-highlight"><img :src="userImage || myRank.avatar || '/static/images/header_1.png'"></span></div>
          <div class="rank-tips">{{myRank.name|| '您'}}当前排名<span>{{myRank.value}}</span>位,超过了<span>{{myRank.ratio}}</span>用户</div>
        </div>
        <div class="list-box">
          <div class="rank-title">
            <span>排名</span>
            <span class="head-img">头像</span>
            <span class="rank-name">名称</span>
            <span>分数</span>
          </div>
          <div class="rank-content" v-for="(data,index) in rankList" :key="index">
            <span>{{data.value || index+1}}</span>
            <span class="head-img">
              <img :src="data.avatar">
            </span>
            <span class="rank-name">{{data.name}}</span>
            <span>{{data.scroe}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--</transition>-->
  </div>
</template>

<script>
import Api from '../../utils/api'
import { UrlParameter } from '../../utils/getUrl'
export default {
  name: 'my_info',
  props: [
    'myRank',
    'userInfo',
    'userImage',
    'haveWeight',
    'bannerH',
    'rankTitle',
    'rankList',
    'pagetype',
    'webType',
    'showMyRank',
  ],
  data() {
    return {
      show: false,
      // tableH: 0, // 表格高度
      // clientH: 0, // 屏幕高度
      celiangH: 0, // 测量box高度
      rankTipH: 0,
      appid: '',
      heightMeasure: 0
    }
  },
  created() {
    this.appid = UrlParameter('appid')
    this.heightMeasure = UrlParameter('height_measure') === "1"
  },
  mounted() {
    console.log(
      'rank-box height',
      window.getComputedStyle(document.getElementsByClassName('rank-box')[0])
        .height,
    )
    console.log(
      'table clientHeight',
      document.getElementsByTagName('table')[0],
      document.documentElement.clientHeight,
    )
    if (document.documentElement.clientWidth < 350) {
      this.celiangH =
        parseFloat(
          window.getComputedStyle(
            document.getElementsByClassName('rank-box')[0],
          ).height,
        ) + 30
    } else {
      this.celiangH =
        parseFloat(
          window.getComputedStyle(
            document.getElementsByClassName('rank-box')[0],
          ).height,
        ) + 10
    }
    // this.clientH = document.documentElement.clientHeight
    if (this.haveWeight) {
      document.getElementsByClassName('celiang-second')[0].style.height =
        this.celiangH + 'px' // 初始化height以实现transition
      document.getElementsByClassName('celiang-second')[0].style.height =
        0 + 'px'
    }
  },
  watch: {
    haveWeight(newValue, oldValue) {
      if (newValue) {
        document.getElementsByClassName('celiang-second')[0].style.height =
          'auto'
      } else {
        document.getElementsByClassName('celiang-second')[0].style.height =
          'auto'
      }
    },
  },
  methods: {
    onclickRank() {
      if (this.pagetype === 'rank') {
        return 0
      }
      console.log(
        'celiang-second height',
        document.getElementsByClassName('celiang-second')[0].style.height,
      )
      if (
        document.getElementsByClassName('celiang-second')[0].style.height ==
        '0px'
      ) {
        document.getElementsByClassName('celiang-second')[0].style.height =
          this.celiangH + 'px'
      } else {
        document.getElementsByClassName('celiang-second')[0].style.height =
          0 + 'px'
      }
    },
    onRouter() {
      const code = localStorage.getItem('code')
      let name = UrlParameter('name') || ''
      let url = Api.host + `EditPage.html?name=${name}&code=${code}&height_measure=${+this.heightMeasure}`
      if (this.appid) {
        url += `&appid=${this.appid}`
      }
      window.location.href = url
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/css/px2rem.scss';
@import '~@/assets/css/common.scss';
* {
  padding: 0;
  margin: 0;
}
@media (min-width: 340px) {
  .head-img {
    margin-left: rem(30);
  }
}
@media (max-width: 340px) {
  .head-img {
    margin-left: rem(15);
  }
}
.edit-span {
  color: white;
  font-size: 14px !important;
  background-color: rgba(255, 255, 255, 0.2);
  width: rem(95);
  height: rem(30);
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  &:before,
  &:after {
    content: '';
    display: block;
  }
  border-radius: rem(30) 0 0 rem(30);
  > img {
    width: rem(14);
    height: rem(14);
  }
}
.user-box {
  margin: 0 auto;
}
.img-box {
  margin: 0 auto;
  border-radius: 50%;
  height: rem(55);
  width: rem(55);
}
.img-inside img {
  width: rem(42);
  height: rem(42);
  border-radius: 50%;
  border: rem(3) solid rgba(255, 255, 255, 0.3);
}
.img-inside {
  display: block;
  border-radius: 50%;
  height: rem(48);
  width: rem(48);
  border: rem(3.5) solid rgba(255, 255, 255, 0.2);
}
.celiang-second {
  width: 100%;
  background-color: #1fd2ba;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  transition: height 0.5s;
}
.rank-name {
  flex-grow: 2;
  overflow: hidden;
}
.rank-box {
  margin: 0 rem(18) 0 rem(18);
  color: #fff;
}
.rank-title {
  @extend .flex;
  justify-content: space-between;
  padding: rem(23) 0 rem(8) 0;
  width: 100%;
  color: #ffdc2e;
}
.list-box {
  box-sizing: border-box;
  /*border-left: rem(10) solid #27a496;*/
  /*border-right: rem(10) solid #27a496;*/
  background-color: #27a496;
  width: 100%;
  height: rem(506);
  margin-bottom: rem(10);
  padding: 0 rem(16);
  border-top-left-radius: rem(10);
  border-top-right-radius: rem(10);
}
.rank-content {
  @extend .flex;
  line-height: rem(45);
  justify-content: space-between;
  height: rem(45);
}
.rank-tips {
  text-align: center;
  font-size: 15px;
  padding: rem(16) 0 rem(20) 0;
  color: #fff;
  position: relative;
}
.rank-tips span {
  color: #ffdc2e;
}
.rank-box span {
  min-width: rem(32);
  text-align: center;
}
.head-img {
  width: rem(35);
}
.head-img img {
  /*background-repeat: no-repeat;*/
  /*background-position: center;*/
  /*background-size: rem(30) rem(30);*/
  width: rem(30);
  height: rem(30);
  margin: rem(7.5) auto;
  border-radius: 50%;
}
.user-content .content-top {
  width: 100%;
}
.content-top .content-top-first {
  width: 100%;
  height: 0.6rem;
  background-color: #1fd2ba;
  /*border-radius: 0.15rem 0.15rem 0 0;*/
}
.top-img {
  width: 0.23rem;
  height: 0.22rem;
  display: inline-block;
  position: relative;
  top: 0;
  left: 50%;
  margin-left: -0.125rem;
}
.content-top-first .top-first-eidt {
  width: 100%;
  padding-left: 0.18rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-first-eidt .we-info {
  font-size: 0.16rem;
  color: #5effdc;
}

.content-top .celiang-second .img {
  position: static;
  float: right;
  margin-top: 0.45rem;
  width: 1rem;
  height: auto;
}
.celiang-enter-active,
.celiang-leave-active {
  transition: all 0.5s;
}
.celiang-enter, .celiang-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/template/my_info.vue